import { useAppUserAccess } from 'global/cnr/contexts/useHelpers/useAppUserAccess';
import _ from 'lodash';
import React, { useContext, useEffect, useState } from 'react';
import { Grid, Icon, Segment } from 'semantic-ui-react';
import { ManifestContext } from '../../cnr/contexts/ManifestContext';
import { PageDataContext } from '../../cnr/contexts/PageDataContext';
import { ParentContext } from '../../cnr/contexts/ParentContext';
import { UiItemContext } from '../../cnr/contexts/UiItemContext';
import { ViewSettingsContext } from '../../cnr/contexts/ViewSettingsContext';
import { g_cns } from '../../common/cns';
import { uniqueKey } from "../../common/keys";
import { appIconTypes } from '../../enums/appIconTypes';
import { gEnums } from "../../enums/globalEnums";
import { PopupIcon } from '../../genericControls/GenericIcon';
import MotionWait from '../../motions/MotionWait';
import UiHeader from '../../pageItem/UiHeader';
import FullPageWrapper from '../../wrappers/FullPageWrapper';
import Wrapper, { wrapperTypes } from '../../wrappers/Wrapper';
import NoData from '../alerts/NoData';
import GroupActionButton from "../buttons/GroupActionButton";
import UiSaveButtons from '../buttons/UiSaveButtons';
import ManifestViewer from '../sem/ManifestViewer';
import { FileViewerContext } from '../sem/SemFileViewer';
import UploaderWithProvider from '../uploading/Uploader';
import FullImage from './FullImage';
import ImagesGrid from './ImagesGrid';
import ProfileImage from './ProfileImage';
import { useStorageUpdate } from 'global/cnr/contexts/useHelpers/useStorageUpdate';
import { FileManagementContext } from 'global/cnr/contexts/FileManagementContext';

const fileActionTypes = {
  approveFiles: 'approveFiles',
  makeProfile: 'makeProfile',
  removeFiles: 'removeFiles',
}

/**
 * Displays the files within storage. 
 * @param {object} props (allowMultiItemSelect, fileViewer_handlers, storageLocationType, storageType, viewerProps)
 * @description Clicking on the image will get and display the full image
 * @description Allows upload using Uploader
 * @note If the list is for manifest icons, displays ManifestViewer
 *  */

const ImageGallery = (props) => {

  const {
    email,
    fromFileManagement,
    refreshing,
    storageLocationType, // pages, pageGallery, etc
    storageType, // image, icon,etc
    viewerProps,
    viewOnly,
  } = props ?? {}

  const parentContext = useContext(ParentContext);
  const { states, handlers } = parentContext ?? {}
  const { paps_state, currentSettings_state, storage_state } = states ?? {}
  const { storage_handlers } = handlers ?? {}

  // authContext  
  const appUserAccess = useAppUserAccess()
  const { appUserSession } = appUserAccess ?? {}
  const { _itemKey: appUserItemKey } = appUserSession ?? {}

  // papsContext 
  const { view, viewKey, pathViews } = paps_state
  const { aps_global, aps_styles, aps_appUserSettings } = _.get(currentSettings_state, 'gvviSettings', {});
  const { appGallery } = aps_global ?? {}
  const { galleryNeedApproval, galleryApprovalAccessLevel, allowAppUserUpload: allowUserUpload_gallery, allowMultiUpload, uploadAccessLevel, gridColumns } = appGallery ?? {}
  const { appUserCollection, allowImageUpload } = aps_appUserSettings ?? {}

  // pageDataContext
  const pageDataContext = useContext(PageDataContext);
  const { pageData_state } = pageDataContext ?? {}
  const { currentPageData } = pageData_state ?? {}
  const { email: email_current } = currentPageData ?? {}

  const _email = email_current ? email_current : email

  // uiItemContext
  const uiItemContext = useContext(UiItemContext);
  const { item_state } = uiItemContext ?? {}
  const { dataName, _dataModificationOpts } = item_state ?? {}
  const { images: images_dm } = _dataModificationOpts ?? {}
  const { allowAppUserUpload: allowUserUpload_pageItem } = images_dm ?? {}

  const pageIsAppUsers = viewKey === appUserItemKey
  const _allowUserUpload = pageIsAppUsers && (allowUserUpload_pageItem || allowUserUpload_gallery) ? true : false

  // storageContext 
  const {
    caption,
    confirmation,
    currentGalleryItems: currentGallery_page,
    appStorageUrlFiles_current,
    fullImageProps,
    galleries,
    galleryFetched,
    galleryFolders,
    galleryType,
    storagePermissions,
    profileStorageFile,
    selectedImages,
    selectedImageProps,
    appStorageUrlFiles,
    showApprovalWizard,
    showImageEdit,
    imageProps_edit
  } = storage_state ?? {}

  let _caption = storageType && storageLocationType ? _.startCase(storageType) + ' (' + _.startCase(storageLocationType) + ')' : 'Caption'

  const {
    page: gallery_page,
    profile: gallery_proflie,
    profileGallery: gallery_proflies,
    pdf: gallery_pdf
  } = galleries ?? {}

  // manifestContext
  const manifestContext = useContext(ManifestContext);
  const { manifest_state } = manifestContext ?? {}
  const { manifestIcons } = manifest_state ?? {}

  // viewSettingsContext
  const viewSettingsContext = useContext(ViewSettingsContext);
  const { viewSettings_handlers } = viewSettingsContext ?? {}

  const fileManagementContext = useContext(FileManagementContext);
  const { fileManagement_state } = fileManagementContext ?? {}
  const { fileManagmentOpts } = fileManagement_state ?? {}
  const { fileOptionType } = fileManagmentOpts ?? {}

  let allowUpload = true;

  if (fileManagmentOpts) {
    _caption = fileManagmentOpts?.viewItemItem?.name || _caption
    if (!fileManagmentOpts.allowUpload) {
      allowUpload = false
    }
  }

  const fileViewerContext = useContext(FileViewerContext);
  const { fileViewer_state, fileViewer_handlers } = fileViewerContext ?? {}
  const { allowMultiItemSelect, fileSelectMode } = fileViewer_state ?? {}

  const _allowMultiItemSelect = true

  const styleAndClass = aps_styles?.[gEnums?.projectStyles?.actionButton] ?? { style: {} };
  styleAndClass.className += ' solo'

  const { fileMode } = viewerProps ?? {}

  let inverted;
  let approvedOnly;
  // let addIcon = 'add'

  const storageUpdate = useStorageUpdate()

  // local state   
  const [showUpload, setShowUpload] = useState()
  const [allowApproval, setAllowApproval] = useState()
  const [profileGallery, setProfileGallery] = useState({})

  const hasGallery = currentGallery_page && Object.keys(currentGallery_page).length > 0
  const hasProfileGallery = profileGallery && Object.keys(profileGallery).length > 0

  const _useFull = storageLocationType === gEnums.storageLocationTypes.event ? false : true

  useEffect(
    () => {

      storage_handlers.handleStart_fetch()

      const _storageProps = {
        allowUserUpload_gallery,
        appUserAccess,
        appUserCollection,
        email: _email,
        galleryApprovalAccessLevel,
        galleryNeedApproval,
        manifestIcons,
        pathViews,
        storageLocationType,
        storageType,
        uploadAccessLevel,
        view,
        viewKey,
      }

      // gets the gallery for the page if does not aleady exist 
      storage_handlers.handleGet_galleryAny(_storageProps)
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [gallery_page, gallery_pdf, gallery_proflie, gallery_proflies, pathViews, confirmation, appUserAccess]
  )

  useEffect(
    () => {
      switch (storageLocationType) {
        case gEnums.storageLocationTypes.profileGallery:
          if (gallery_proflies) {
            setProfileGallery(gallery_proflies[_email])
          }
          break;
        default:
        // nothing
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [gallery_proflies && gallery_proflies[_email]]
  )

  useEffect(
    () => {
      let allow_userUpload;
      switch (storageLocationType) {
        case gEnums.storageLocationTypes.pageGallery:
        case gEnums.storageLocationTypes.pages:
          allow_userUpload = (storagePermissions.allowUpload && !storagePermissions.allowHeader) || _allowUserUpload
          break;
        case gEnums.storageLocationTypes.profileGallery:
          allow_userUpload = (storagePermissions.allowUpload && !storagePermissions.allowHeader)
          // setShowUpload(true)
          break;
        default:
          allow_userUpload = (storagePermissions.allowUpload && !storagePermissions.allowHeader)
        // nothing
      }
      const allowAp = (storagePermissions.allowApprove && !storagePermissions.allowHeader)
      setAllowApproval(allowAp)
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [storagePermissions]
  )

  useEffect(
    () => {
      if (confirmation && viewSettings_handlers) {
        viewSettings_handlers.handleStopUpdate()
        handleRefresh()
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [confirmation]
  )

  useEffect(
    () => {
      if (refreshing) {
        storage_handlers.handleClear_gallery(galleryType)
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [refreshing]
  )

  useEffect(
    () => {
      if (fromFileManagement) {
        storage_handlers.handleGet_globalStorageFiles(storageLocationType, storageType)
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [fromFileManagement, storageType]
  )

  const handleImageClick = (e, imageProps) => storage_handlers.handleClick_image(imageProps)
  const handlePdfClick = (e, src) => storage_handlers.handlePdfClick(e, src)
  const handleRefresh = () => storage_handlers.handleGet_globalStorageFiles(storageLocationType, storageType)
  const handleShowApprovalWizard = () => storage_handlers.handleShow_approvalWizard()
  const handleShowUpload = () => setShowUpload(!showUpload)

  const handleCancel = () => {
    switch (storageLocationType) {
      case gEnums.storageLocationTypes.profileGallery:
        setShowUpload(!showUpload)
        break;
      case gEnums.storageLocationTypes.pages:
        if (showUpload) {
          setShowUpload(false)
        } else {
          props.handleCancel && props.handleCancel()
        }
        break;
      default:
        props.handleCancel && props.handleCancel()
        setShowUpload(false)
    }
  }

  /**
   * triggers the action of the confirmation
   * @param {*} fileActionType 
   * @returns 
   */
  const handleConfirm = (fileActionType) => {
    // storage_handlers.handleStartUpdate() 
    switch (fileActionType) {
      // case fileActionTypes.approveFiles:
      //   return storage_handlers.handleApprove_selected()
      case fileActionTypes.removeFiles:
        storageUpdate.removeItemsFromStorage(selectedImageProps, fileManagmentOpts)
      // return storage_handlers.handleDelete_selected()
      // case fileActionTypes.makeProfile:
      //   return storage_handlers.handleSet_profile()
      default:
        break;
    }
  }

  /** Ammends the storage's selectedImages  */
  const handleImageSelect = (e, imageProps) => {
    const { documentKey, imageKey: selectedKey } = imageProps ?? {}
    e && e.stopPropagation()
    if ((storagePermissions.allowApprove && showApprovalWizard)) {
      storage_handlers.handleApprove_image(selectedKey, documentKey)
    } else if (storagePermissions.allowDelete) {
      storage_handlers.handleSelect_image(imageProps, selectedKey, documentKey, _allowMultiItemSelect)
    } else if (storagePermissions.allowSelect) {
      storage_handlers.handleSelect_image(imageProps, selectedKey, documentKey, _allowMultiItemSelect)
    }
  }

  const handleImageEdit = (e, imageProps) => {
    storage_handlers.handleSet_imageEdit(imageProps)
  }

  const imageGridProps = {
    approvedOnly,
    handlers: {
      handleImageClick,
      handleImageSelect,
      handleImageEdit,
      handlePdfClick,
    },
    storagePermissions,
    selectedImages,
    showApprovalWizard,
    documentKey: null,
    isFullGalleryItem: false,
    gallery: null,
    appStorageUrlFiles_current,
    fileManagmentOpts,
  }

  /** Ammends the fieldProp's value */
  const handleAmmendFieldProp = () => fileViewer_handlers && fileViewer_handlers.handleSelectSave(selectedImages)

  /** Returns a Grid with images of a single document */
  const pageGalleryGrid = (cg, documentKey, isFullGalleryItem) => {
    const _currentGallery = cg ? cg : currentGallery_page
    let _current_gallery;
    switch (storageLocationType) {
      case gEnums.storageLocationTypes.pages:
        _current_gallery = [_currentGallery]
        break;
      default:
        _current_gallery = _currentGallery
    }
    imageGridProps.documentKey = documentKey
    imageGridProps.isFullGalleryItem = isFullGalleryItem
    imageGridProps.gallery = _current_gallery
    imageGridProps.gridColumns = gridColumns
    imageGridProps.dataName = dataName
    imageGridProps.origin = 'imageGallery'
    imageGridProps.storageLocationType = storageLocationType
    imageGridProps.imageOwner = _email
    return <ImagesGrid igProps={imageGridProps} viewOnly={viewOnly} />
  }

  /** Returns a Grid with images of a single document */
  const pdfGalleryGrid = (cg, documentKey, isFullGalleryItem) => {
    const _currentGallery = cg ? cg : currentGallery_page
    imageGridProps.documentKey = documentKey
    imageGridProps.isFullGalleryItem = isFullGalleryItem
    imageGridProps.gallery = _currentGallery
    imageGridProps.isPdf = true
    imageGridProps.gridColumns = gridColumns
    imageGridProps.origin = 'imageGallery'
    imageGridProps.storageLocationType = storageLocationType
    return <ImagesGrid igProps={imageGridProps} />
  }

  /** Returns a list of images from `appStorageUrlFiles_current` */
  const globalImagesGrid = () => {
    imageGridProps.gallery = appStorageUrlFiles_current
    imageGridProps.storageType = storageType
    imageGridProps.origin = 'imageGallery'
    imageGridProps.storageLocationType = storageLocationType
    return <ImagesGrid igProps={imageGridProps} />
  }

  /** Returns all the images for all the items in the `gallery_page` */
  const fullGalleryGrid = () => {
    const columns = []
    Object.keys(galleryFolders).forEach(key => {
      columns.push(<Grid.Column key={key} textAlign="center">
        <Icon name='folder' size={'huge'} color="blue" />
        {key}
      </Grid.Column>)
    })
    return <Grid columns={gridColumns ? gridColumns : 3}> {columns}</Grid>
  }

  /** Retuns one `Segment.Group` of images for each document */
  const documentsGalleryGrid = () => {
    const segs = []
    Object.keys(gallery_page).forEach(documentKey => {
      const fg = gallery_page[documentKey]
      const sg = <Segment.Group key={uniqueKey('sim', 'dgg', documentKey)}>
        <Segment key={uniqueKey('sim', 'dgg', documentKey, 'a')}>{_.startCase(documentKey)}</Segment>
        <Segment key={uniqueKey('sim', 'dgg', documentKey, 'b')}>{pageGalleryGrid(fg, documentKey, true)}</Segment>
      </Segment.Group>
      segs.push(sg)
    })
    return segs
  }

  // this will show if showUpload = true
  const uploader = () => <UploaderWithProvider
    allowMultiUpload={allowMultiUpload}
    handleCancel={handleCancel}
    origin={'imageGallery'}
    storageLocationType={storageLocationType}
    storageType={storageType}
    useFull={_useFull}
  />

  const noData = () => viewOnly ? null : <NoData altCaption={'Images'} />

  const wrapperContent = () => {

    if (!galleryFetched) {
      return !viewOnly && <MotionWait origin={'ImageGallary'} />
    } else {
      if (showUpload) {
        // IMPORTANT: Uploader  
        return uploader()
      } else {
        if (fullImageProps) {
          return <FullImage
            fullImageProps={fullImageProps}
            email={_email}
            handleClose={storage_handlers.handleClose_bigImage}
            storageLocationType={storageLocationType}
            viewOnly={viewOnly} />
        } else if (showImageEdit && imageProps_edit) {
          return uploader()
        } else {
          switch (storageLocationType) {

            case gEnums.storageLocationTypes.clientProfiles:
              return hasGallery ? pageGalleryGrid(null, storageLocationType) : noData()

            case gEnums.storageLocationTypes.profileGallery:
              return hasProfileGallery ? pageGalleryGrid(profileGallery, storageLocationType) : noData()

            case gEnums.storageLocationTypes.fullGallery:
              if (showApprovalWizard) {
                return gallery_page ? documentsGalleryGrid() : noData()
              } else {
                return galleryFolders ? fullGalleryGrid() : noData()
              }

            case gEnums.storageLocationTypes.profiles:
              return <ProfileImage profileStorageFile={profileStorageFile} />

            case gEnums.storageLocationTypes.eventGallery:
            case gEnums.storageLocationTypes.pages:
            case gEnums.storageLocationTypes.pageGallery:
              // case gEnums.storageLocationTypes.profileGallery:
              return hasGallery ? pageGalleryGrid(null, storageLocationType) : noData()

            case gEnums.storageLocationTypes.pagePdf:
              return hasGallery ? pdfGalleryGrid(null, storageLocationType) : <NoData altCaption={'PDfs'} />

            default:
              switch (storageType) {
                case gEnums.storageTypes.manifest:
                  return <ManifestViewer />
                default:
                  return appStorageUrlFiles_current ? globalImagesGrid() : noData()
              }
          }
        }
      }
    }
  }

  const gab_approve = () => <GroupActionButton key={uniqueKey('sim', 'a')} handleConfirm={handleConfirm} actionName={fileActionTypes.approveFiles} defaultIcon={'check'} confirmation={confirmation} saveIcon={'check'} itemCount={_.size(selectedImages)} />
  const gab_delete = () => <GroupActionButton key={uniqueKey('sim', 'd')} handleConfirm={handleConfirm} actionName={fileActionTypes.removeFiles} defaultIcon={'trash alternate outline'} confirmation={confirmation} saveIcon={'check'} itemCount={_.size(selectedImages)} />
  const gab_profile = () => <GroupActionButton key={uniqueKey('sim', 'p')} handleConfirm={handleConfirm} actionName={fileActionTypes.makeProfile} defaultIcon={'user circle'} saveIcon={'check'} />
  const gab_fieldProp = () => <GroupActionButton key={uniqueKey('sim', 'f')} actionName={'select'} handleConfirm={handleAmmendFieldProp} defaultIcon={'check'} confirmation={confirmation} saveIcon={'check'} />

  const footerSingleButton = () => {
    switch (storageLocationType) {
      case gEnums.storageLocationTypes.profiles:
        return gab_profile()
      default:
      // nothing
    }
  }

  const footerSelectedButton = () => {
    const btns = []
    switch (fileMode) {
      case gEnums.fileModes.viewManifest:
      case gEnums.fileModes.viewWithSelect:
      case gEnums.fileModes.viewWithModify:
      case gEnums.fileModes.viewWithPick:
        return gab_fieldProp()
      case gEnums.fileModes.view:
        btns.push({ oc: handleConfirm, caption: 'Delete', icon: 'delete' })
        if (storagePermissions.allowDelete) {
          return gab_delete()
        } else if (storagePermissions.allowApprove && showApprovalWizard) {
          return gab_approve()
        }
        break;
      default:
        if (storagePermissions.allowDelete) {
          return gab_delete()
        } else if (storagePermissions.allowApprove && showApprovalWizard) {
          return gab_approve()
        }
    }
  }

  const header = () => {
    switch (fileSelectMode?.key) {
      case 'filePicker':
        return;
      default:
        if (fullImageProps) {
          const icon1 = { handleOnClick: handleImageClick, icon: appIconTypes.delete, inverted }
          return <UiHeader caption={_.startCase(storageType)} icons={[icon1]} storageType={storageType} isSingle={true} />
        } else {
          if (showImageEdit) {
            const icon1 = showImageEdit && { handleOnClick: storage_handlers.handleSet_imageEdit, showAdd: showUpload, inverted, icon: 'ban', title: 'Cancel', color: 'red' }
            return <UiHeader caption={_caption} icons={[icon1]} />
          } else {
            const icons = []
            if (allowUpload) {
              icons.push({ handleOnClick: storagePermissions.allowUpload ? handleShowUpload : null, showAdd: showUpload, inverted })
              icons.push({ handleOnClick: storagePermissions.allowRefresh ? handleRefresh : null, showAdd: showUpload, inverted, icon: 'refresh', title: 'Refresh' })
            }
            return <UiHeader caption={_caption} icons={icons} />
          }
        }
    }

  }

  const footer_upload = () => {
    const btns = [{ caption: 'Add', oc: handleShowUpload, icon: 'add', color: 'blue' }]
    if (!_.isEmpty(selectedImages)) {
      btns.push({ caption: 'Remove', oc: handleShowUpload, icon: 'arrow right', color: 'blue' },)
    }
    return <UiSaveButtons others={btns} />
  }

  const footer = () => {
    switch (storageLocationType) {
      case gEnums.storageLocationTypes.profileGallery:
      case gEnums.storageLocationTypes.pages:
        return allowImageUpload && !showUpload && footer_upload()
      default:
        if (!_.isEmpty(selectedImages)) {
          if (fullImageProps) {
            return footerSingleButton()
          } else {
            if (!showImageEdit && !showUpload) {
              return footerSelectedButton()
            }
          }
        }
    }
  }

  const wrapper = () => <Wrapper
    header={header()}
    content={wrapperContent()}
    footer={!viewOnly && footer()}
    wrapperType={wrapperTypes.padded}
    noMid={true}
    updating={false}
  />

  const approvalWrapper = () => <Wrapper
    header={storagePermissions.allowHeader && !props.fip ? header() : null}
    content={wrapperContent()}
    footer={!showUpload && footer()}
    noMid={true}
    wrapperType={wrapperTypes.paddedHeader}
  />

  const approvalWizard = () => <FullPageWrapper
    content={approvalWrapper()}
    handleCancel={handleShowApprovalWizard}
    topperCaption={caption ? 'Approve ' + caption : 'Approve Items'}
  />

  const pi = (onClick, iconName, size, styleAndClass, altCn, color) => <PopupIcon piProps={{ onClick, iconName, size, styleAndClass, altCn, color }} />

  const approvalPopup = () => pi(handleShowApprovalWizard, 'check', 'large', styleAndClass, g_cns.item_popup_solo_right)

  const content = () => <React.Fragment>
    {wrapper()}
    {/* {(allowAdminUpload || allowAppUserUpload) && uploadPopup()} */}
    {allowApproval && approvalPopup()}
  </React.Fragment>

  const fullPageWrapper = () => <FullPageWrapper
    content={showApprovalWizard ? approvalWizard() : content()}
    footer={footer()}
    handleCancel={handleCancel}
    topperCaption={'Image Gallery'}
    topperCaption2={_.startCase(storageLocationType)}
  />

  if (props.handleCancel) {
    return fullPageWrapper()
  } else {
    return showApprovalWizard ? approvalWizard() : wrapper()
  }
}

export default ImageGallery